import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { IMG, ROOMS } from "@/data/site";

export default function Rooms() {
  return (
    <div data-testid="rooms-page">
      <PageHero overline="Stay With Us" title="Accommodation" subtitle="Two ways to rest — Superior and Standard, each layered in island calm." image={IMG.bungalowsRow} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12 space-y-20 md:space-y-28">
        {ROOMS.map((room, i) => (
          <FadeUp key={room.slug}>
            <div className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <Link to={`/rooms/${room.slug}`} className="lg:col-span-7 img-zoom block aspect-[16/10] [direction:ltr]" data-testid={`room-image-${room.slug}`}>
                <img src={room.image} alt={room.name} className="w-full h-full object-cover" />
              </Link>
              <div className="lg:col-span-5 [direction:ltr]">
                <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-3">{String(i + 1).padStart(2, "0")} — {room.occupancy} · {room.bed}</p>
                <h2 className="font-serif-display text-3xl md:text-4xl font-light text-white">{room.name}</h2>
                <p className="mt-4 text-[#a3a3a3] leading-relaxed">{room.short}</p>
                <div className="mt-8 flex flex-wrap gap-4">
                  <Link to={`/rooms/${room.slug}`} className="btn-outline-gold px-6 py-3 text-[12px] tracking-[0.18em] uppercase inline-flex items-center gap-2" data-testid={`room-detail-btn-${room.slug}`}>
                    View Room <ArrowRight size={15} />
                  </Link>
                  <Link to="/book" className="btn-gold px-6 py-3 text-[12px] tracking-[0.18em] uppercase font-semibold" data-testid={`room-book-btn-${room.slug}`}>Book Now</Link>
                </div>
              </div>
            </div>
          </FadeUp>
        ))}
      </section>
    </div>
  );
}
